import { isAllowed } from '@edreamsodigeo/frontend-cmp-client';
import { queryString } from './URLUtils';

export const CookieUtils = {
    readCookies: () => {
        return queryString(document.cookie, ';'); // eslint-disable-line no-restricted-properties
    },

    readCookie: (name) => {
        return isAllowed('cookies', name) ? CookieUtils.readCookies()[name]: null;
    },
};
